<template>
<div>
  <div>
    <div class="box" v-bind:style="background">
      <Title :title="title" :message="message"/>
    </div>
    <div class="contact">
      <a href="#office-box" class="contact-box">お問い合わせはこちら</a>
    </div>
    <div class="container-fluid content">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/cargo-content-1-2.png"/>
        </div>
        <div class="col-xs-12 col-lg-5 order-md-first disc">
          <div class="table-container">
            <div class="table-title text">
              <div class="table-caption">
                車両案内
              </div>
              最大積載量50tまで、ご要望に合わせて車両を用意いたします。
            </div>
            <table class="table type-table">
              <tbody>
                <tr>
                  <th class="no-border">大型トレーラー（20t~50t）</th>
                  <td class="no-border">20台</td>
                </tr>
                <tr>
                  <th class="no-border"> 大型トラクタ（16~20t）</th>
                  <td class="no-border">13台</td>
                </tr>
                <tr>
                  <th class="no-border"> 大型トラック（11~15t）</th>
                  <td class="no-border">7台</td>
                </tr>
                <tr>
                  <th class="no-border">ラフタークレーン（25t）</th>
                  <td class="no-border">2台</td>
                </tr>
                <tr>
                  <th class="no-border">ウィングトレーラー（19.5t）</th>
                  <td class="no-border">1台</td>
                </tr>
                <tr>
                  <th class="no-border">ピータービルト コンボイ<br>（イベント用）</th>
                  <td class="no-border">1台</td>
                </tr>
              </tbody>
            </table>
            <a href="/static/toei_pamphlet_20240301.pdf" class="box4">
              <p>パンフレットPDFのダウンロード</p>
              <div class="arrow01"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid content-actual">
      <div class="row">
        <div class="col-xs-12 col-lg-7 resizeimage">
          <img src="@/assets/cargo-content-2.png"/>
        </div>
        <div class="col-xs-12 col-lg-5 resizeimage disc-actual">
          <div class="table-container-actual">
            <div class="table-title text">
              <div class="table-caption">
                実績
              </div>
              蓄積された知見をもとに、<br>全国へ安心・正確な輸送をしています。
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <td class="text">主な輸送物<br>
                  建設機械
                  精密機械
                  プラント材
                  橋梁材
                  各種重量物
                  各種ボート</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="ex-container">
          <div class="ex">
            <img src="@/assets/cargo-icon-1.png">
            <h1 class="ex-title">積載物</h1>
            <p>大型、重量品など</p>
          </div>
          <div class="ex">
            <img src="@/assets/cargo-icon-2.png">
            <h1 class="ex-title">重量</h1>
            <p>0～50t</p>
          </div>
          <div class="ex">
            <img src="@/assets/cargo-icon-3.png">
            <h1 class="ex-title">輸送範囲</h1>
            <p>北海道～九州</p>
          </div>
          <div class="ex">
            <img src="@/assets/cargo-icon-4.png">
            <h1 class="ex-title">付随業務</h1>
            <p>許可申請<br>誘導・陸送</p>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container-permit">
      <div class="permit">
        <div class="permit-backgroud">
          <div class="table-title">
            <div class="table-caption">
              許可申請
            </div>
          </div>
          <table class="table-permit">
            <tbody>
              <tr>
                <td class="text">
                  貨物の輸送には、許可申請が必要になることがあります。
                  東栄運輸では、お客さまの輸送にかかわる申請を実施いたします。
                  ＜主な許可申請＞
                  <li>特殊車両通行許可</li>
                  <li>制限外積載許可</li>
                  <li>通行禁止道路通行許可</li>
                  <li>道路使用許可</li>
                  このほかにもございます。
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="table-container">
      <div class="table-title-service">
        <div class="table-caption">
          サービスの流れ
        </div>
        経験豊富な社員が対応いたします。
      </div>
      <div class="flow-container">
        <div class="flow">
          <h1 class="flow-title">1</h1>
          <h2>お問い合わせ</h2>
          <img src="@/assets/cargo-icon-5.png">
        </div>
        <div class="flow">
          <h1 class="flow-title">2</h1>
          <h2>お打ち合わせ</h2>
          <img src="@/assets/cargo-icon-6.png">
        </div>
        <div class="flow">
          <h1 class="flow-title">3</h1>
          <h2>提案・見積り</h2>
          <img src="@/assets/cargo-icon-7.png">
        </div>
        <div class="flow">
          <h1 class="flow-title">4</h1>
          <h2>輸送</h2>
          <img src="@/assets/cargo-icon-8.png">
        </div>
        <div class="flow">
          <h1 class="flow-title">5</h1>
          <h2>請求・お支払</h2>
          <img src="@/assets/cargo-icon-9.png">
        </div>
      </div>
    </div>
    <div class="container-fluid content-office">
      <div class="caption">
          営業所
      </div>
      <div class="container contact-container">
        <a id="office-box" class="row office-box">
          <div class="col-xs-12 col-lg-6 contact">
            <span>さいたま第一営業所</span>
            〒339-0011 埼玉県さいたま市岩槻区長宮77
            T:048-799-1212｜F:048-799-0623
          </div>
          <div class="col-xs-12 col-lg-6 contact">
            <span>土浦営業所</span>
            〒300-0012 茨城県土浦市神立東2-30-25
            T:029-831-6654｜F:029-831-6659
          </div>
        </a>
      </div>
      <div class="container contact-box2">
        <div class="contact-box-title">
        貨物お問い合わせ先
        </div>
        <div class="contact-box-text">
          <h1>お問い合わせ、お見積りなど<br class="newline">お気軽にご相談ください</h1>
          <table class="phone">
            <tbody>
              <tr>
                <th>さいたま第一営業所</th>
                <td><a href="tel:048-799-1212">048-799-1212</a></td>
              </tr>
              <tr>
                <th>土浦営業所</th>
                <td><a href="tel:029-831-6654">029-831-6654</a></td>
              </tr>
            </tbody>
          </table>
          <h2>受付時間 8：00-18：00<br class="newline">（日・祝・年末年始を除く）</h2>
        </div>
      </div>
    </div>
  </div>
  <script type="application/ld+json">
    {
      "@context": "http://schema.org/",
      "@type": "JobPosting",
      "title": "トラックドライバー",
      "description": "<p>大型トラックによる建設機械等の輸送</p>\n<p>※輸送エリアは首都圏を主体に全国展開となります。</p>\n<p>昭和42年に設立した『東栄運輸』。</p>\n<p>大手企業のお客様とも多数取引を交わす安定企業です。</p>\n<p>新会社の設立に伴い、【ドライバー】として活躍してくれる新メンバーを大募集！</p>\n<p>大型トラックで、建設機械などの輸送をお願いします。</p>\n<p>日・祝＋夏季・年末年始の連休もあり、メリハリのある働き方が叶います。</p>",
      "datePosted": "2020-12-01",
      "validThrough": "2021-06-01",
      "employmentType": "FULL_TIME",
      "hiringOrganization": {
        "@type": "Organization",
        "name": "東栄運輸株式会社",
        "sameAs": "https://www.toei.myweb.co.jp/cargo"
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressRegion": "埼玉県",
          "addressLocality": "さいたま市",
          "streetAddress": "岩槻区長宮77",
          "postalCode": "339-0011",
          "addressCountry": "JP"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "JPY",
        "value": {
          "@type": "QuantitativeValue",
          "value": "290000",
          "minValue": "290000",
          "maxValue": "400000",
          "unitText": "MONTH"
        }
      }
    }
  </script>
</div>
</template>

<script>
import Title from '@/components/Title.vue'

export default {
  components: {
    Title
  },
  data () {
    return {
      background: {
        background: '',
        position: 'relative',
        height: '100vh',
        minHeight: '300px',
        backgroundSize: 'cover',

        display: 'flex',
        flexDirection: 'column',

        letterSpacing: '0',
        color: '#FFFFFF'
      },
      title: 'FREIGHT',
      message: '技術と信頼で、大型輸送50年。'
    }
  },
  created () {
    this.background.background = "url('" + require('../assets/cargo.jpg') + "') no-repeat center center"
  }
}
</script>

<style scoped>
.content {
  padding-top: 5%;
  max-width: 1280px;
}
.content-actual {
  padding: 5% 5% 0 5%;
  max-width: 100%;
  background-color: #F7C37A;
}
.content-office {
  padding: 2% 4% 4% 4%;
  max-width: 100%;
}
.table-container {
  padding: 2% 4% 4% 4%;
  white-space: pre-line;
}
.table-container-actual {
  padding: 4%;
  white-space: pre-line;
  background-color: #FFF;
  height: 705px;
}
.table-container-permit {
  padding: 4% 2%;
  white-space: pre-line;
}
.table-container.last {
  padding-bottom: 40px;
}
.table td {
  color: #000000;
  vertical-align: middle;
  border-top: none;
  padding-left: 20px;
}
.table th {
  font-size: 24px;
  color: #000000;
  vertical-align: middle;
  border-top: none;
  padding-left: 20px;
}
.type-table {
  font-size: 24px;
}
.type-table td{
  font-size: 24px;
  text-align: end;
}
.permit {
  background-image: url("../assets/cargo-content-4.jpg");
  background-size: cover;
}
.permit-backgroud {
  background-color: rgba(255,255,255,0.8);
  padding: 2%;
}
.table-permit td {
  color: #000000;
  vertical-align: middle;
  border-top: none;
  padding: 30px 100px;
}
@media screen and (max-width: 1280px) {
  .type-table td {
    font-size: 20px;
    padding-left: 0;
    padding-right: 0;
    width: 20%;
  }
  .type-table th {
    font-size: 20px;
  }
}
.link {
  padding: 2%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box6 {
  border: 2px solid #a6a6a6;
  padding: 10px 50px;
  background: #FFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  width: 500px;
  min-width: 170px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 50px;
}
.box6 p {
  font-size: 20px;
  font-weight: 600;
  color: #000;
  margin: 0;
  padding: 0;
}
.arrow01 {
  display: block;
  width: 12px;
  height: 12px;
  border-top: solid 3px #FFF;
  border-right: solid 3px #FFF;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: 13%;
}
.table a{
  font-size: 16px;
}
.table .no-border {
  border-top: none;
}
.text {
  font-size: 22px;
}
.table-title {
  color: #000000;
  font-size: 32px;
  font-weight: bold;
  padding-bottom: 20px;
  position: relative;
}
.table-title-service {
  color: #000000;
  font-size: 32px;
  font-weight: bold;
  padding-bottom: 20px;
  position: relative;
  text-align: center;
}
.table-caption {
  position: absolute;
  top: -16%;
  font-size: 16px;
  color: #000;
  font-weight: normal;
  border-bottom: 2px solid #e89511;
}
.caption {
  position: absolute;
  font-size: 16px;
  color: #000;
  font-weight: normal;
  border-bottom: 2px solid #e89511;
}
.resizeimage {
  padding-right: 0px;
  padding-left: 0px;
  text-align: end;
  min-width: 240px;
}
.resizeimage img {
  width: 100%;
}
.resizeimage a {
  font-size: 10px;
  padding-right: 2%;
}
.disc {
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: left;
}
.disc-actual {
  padding-bottom: 8px;
  text-align: left;
}
.disc-caption {
  text-align: end;
}
.box4 {
  border: 2px solid #e89511;
  padding: 5px 14px;
  margin-top: 20px;
  margin-bottom: 11px;
  background: #e89511 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
}
.box4 p {
  font-size: 20px!important;
  font-weight: 600;
  color: #FFF;
  margin: 0;
  padding: 0;
}
.arrow02 {
  display: block;
  width: 12px;
  height: 12px;
  border-top: solid 3px #FFF;
  border-right: solid 3px #FFF;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: 13%;
}
.ex-container {
  display: flex;
  margin: auto;
  padding: 2% 0;
}
.ex {
  margin: 10px 20px 10px 0;
  padding: 10px;
  width: 280px;
  background-color: #FFF;
  text-align: center;
  border-radius: 10px;
}
.ex img {
  max-width: 148px;
  padding-bottom: 20px;
}
.ex h1 {
  font-size: 24px;
  font-weight: bold;
}
.flow-container {
  display: flex;
  margin: auto;
  padding: 2% 1%;
  position: relative;
}
.flow {
  margin: 10px 55px 10px 0;
  padding: 10px;
  width: 200px;
  position: relative;
  text-align: center;
  background-color: #F7C37A;
}
.flow::before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  margin: auto;
  top: 0px;
  right: -45px;
  border-style: solid;
  border-color: transparent transparent transparent #F7C37A;
  border-width: 98px 0 98px 45px;
}
.flow h1 {
  height: 30px;
  width: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 42px;
  font-weight: bold;
  color: #FFF;
  padding: 5px;
}
.flow h2 {
  color: #000;
  font-size: 20px;
  font-weight: bold;
  padding: 20px 0;
}
.flow p {
  font-size: 14px;
  text-align: center;
}
.flow img {
  max-width: 110px;
  padding-bottom: 10px;
}
.contact-container {
  padding-top: 40px;
  padding-bottom: 40px;
  white-space: pre-line;
  position: relative;
}
.contact-box {
  border: 2px solid #e89511;
  font-size: 32px;
  font-weight: 600;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 25px 20px 25px 20px;
  margin: 20px 100px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  text-align: center;
}
.contact-box p {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
  text-align: left;
}
.contact-box p.tel {
  font-size: 36px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.office-box {
  padding: 0px 10% 0px 12%;
}
.contact {
  padding-top: 12px;
  padding-bottom: 12px;
}
.contact span {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}
.contact-box2 {
  padding-bottom: 40px;
}
.contact-box-title {
  font-size: 32px;
  color: #FFF;
  background-color: #E89511;
  padding-left: 20px;
}
.contact-box-text {
  border: 2px solid #E89511;
  padding: 20px;
  text-align: center;
  color: #000;
}
.contact-box-text h1 {
  font-size: 24px;
}
.newline {
  display: none;
}
.phone {
  margin: 0 auto;
  font-size: 28px;
}
.phone th {
  text-align: right;
  padding-right: 20px;
}
.phone td a {
  color: #000;
}
.contact-box-text h2 {
  text-align: center;
  font-size: 28px;
}
@media screen and (max-width: 480px) {
  .contact-box {
    font-size: 26px;
    padding: 10px;
    margin: 20px 20px;
  }
  .office-box {
    padding: 0px;
  }
  .contact {
    font-size: 16px;
  }
  .contact span {
    font-size: 17px;
  }
  .resizeimage {
    padding-right: 5%;
    padding-left: 5%;
  }
  .table-title {
    font-size: 22px;
  }
  .table-caption {
    top: -20%;
  }
  .table-container-actual {
    height: 455px;
  }
  .table-title-service {
    font-size: 20px;
    padding: 10px 5px;
  }
  .permit-backgroud {
    background-color: #FFF;
  }
  .table-permit td {
    padding: 30px 20px;
    font-size: 20px;
  }
  .ex-container {
    padding: 2% 1%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .ex {
    margin: 10px;
    width: 165px;
  }
  .ex img {
    max-width: 100px;
  }
  .ex h1 {
    font-size: 20px;
  }
  .flow {
    margin: 10px 20px 30px 20px;
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
  }
  .flow-container {
    display: block;
  }
  .flow::before {
    bottom: -104px;
    left: -45px;
    border-color: #F7C37A transparent transparent transparent;
    border-width: 25px 155px 0px 155px;
  }
  .flow h1 {
    height: 15px;
    width: 15px;
    font-size: 22px;
  }
  .flow h2 {
    font-size: 18px;
    margin: 0;
    padding: 20px 0px 15px 31px;
    width: 50%;
    vertical-align: middle;
  }
  .flow img {
    width: 95px;
    height: 60px;
    padding-bottom: 0px;
  }
  .contact-container {
    padding-bottom: 20px;
  }
  .contact-box-title {
    font-size: 20px;
    background-color: #E89511;
  }
  .contact-box-text {
    padding: 20px 10px;
  }
  .contact-box-text h1 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .newline {
    display: block;
  }
  .phone {
    font-size: 16px;
  }
  .phone th {
    padding-right: 7px;
    font-size: 16px;
  }
  .phone td {
    font-size: 17px;
  }
  .contact-box-text h2 {
    font-size: 16px;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Freight.vue